/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
// import cogoToast from 'cogo-toast';
import { Button } from 'react-bootstrap';
import Draggable from 'react-draggable';
import { useForm, useWatch } from 'react-hook-form';
import PasswordChecklist from "react-password-checklist"
import { shallowEqual, useSelector } from 'react-redux';

import { TextFieldInputOnChange } from '@components/RHF/TextFieldInputOnChange';
import { ShowToast } from '@helpers/ToastHelper';
import { Dialog, DialogActions, DialogContent, DialogTitle }
  from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { Paper } from '@material-ui/core';
import TextFieldInput from '@partialcomponents/TextFieldInput';

import { useGetPasswordSettings, useSaveUsersNewPassword } from './_apiChangePassword';
// import TextFieldInput from '../../_metronic/_partials/controls/TextFieldInput';
// import * as actions from "./_redux/ChangePassword/changePasswordActions";
import schema from './ChangePasswordSchema';

function PaperComponent(props) {
  return (
    <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const ChangePasswordDialog = (props) => {
  const { open, setConfirmDialogOpen } = props;

  const { control, setValue, trigger, getValues, clearErrors, reset, formState: { errors, isValid } } = useForm({ mode: 'all', defaultValues: { oldpassword: '', newpassword: '', verifypassword: '' } });
  const properties = {
    errors,
    clearErrors,
    schema,
    control,
    getValues,
    setValue,
    trigger,
  };

  const styleUserEntry = {
    AppBar: {
      position: 'relative',
      backgroundColor: '#F4F5F8'
    },
    Title: {
      marginLeft: '10px',
      flex: 1,
      color: '#333333',
      fontWeight: 700, fontSize: 20
    },
    DialogActions: {
      backgroundColor: '#393A3D'
    },
    DialogContent: {
      backgroundColor: '#F4F5F8'
    }, Close: {
      color: '#6B6C72',
      fontSize: '1.5rem',
      paddingTop: 0
    }, CheckboxInputMargin: { marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 },
    InputTopMargin: {
      marginTop: 0,
      paddingTop: 0
    }, HeaderSeparator: {
      marginTop: 10,
      fontWeight: 500
    }, Label: {
      marginTop: 5,
      paddingTop: 0
    }, HeaderBeginClose: {
      marginTop: 20
    }, CloseBox: {
      marginTop: -10
    }, TitleIcon: {
      fontSize: 24, color: '#000'
    },
  }

  const [passwordCheckListSettings, setPasswordCheckListSettings] = useState({
    password_length: 5,
    password_special_chars: true,
    password_with_number: true,
    password_with_capital: true,
    rules: ["length", "specialChar", "number", "capital", "match"]
  });

  const { currentUser } = useSelector((state) => ({ currentUser: state?.auth?.user?.user }), shallowEqual);
  const _apiPasswordSettings = useGetPasswordSettings();
  const _apiSaveNewPassword = useSaveUsersNewPassword();

  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(actions.GetPasswordSettings());
  // }, [open, dispatch]);

  // const { PasswordSettings, currentUser, saveStatus } = useSelector(
  //   (state) => ({
  //     PasswordSettings: state.changepassword.passwordsettings,
  //     currentUser: state.auth.user.user,
  //     saveStatus: state.changepassword.saveStatus
  //     // cancelStatus: state.dayentry.cancelStatus
  //   }), shallowEqual
  // );

  const handleDialogClose = () => {
    reset();
    clearErrors();
    setConfirmDialogOpen(false);
  }

  // useEffect(() => {
  //   if (saveStatus && saveStatus.success) {
  //     const { hide } = cogoToast.success("Password successfully changed", { position: "top-right", onClick: () => { hide(); } });
  //     handleDialogClose();
  //     dispatch(actions.ResetSavePasswordStatus());
  //   } else if (saveStatus && !saveStatus.success && (saveStatus.error || '').length > 0) {
  //     const { hide } = cogoToast.error(saveStatus.error, { position: "top-right", onClick: () => { hide(); } });
  //     dispatch(actions.ResetSavePasswordStatus());
  //   }
  // }, [saveStatus])

  useEffect(() => {

    if (!_apiPasswordSettings.data) return;
    console.log(_apiPasswordSettings.data);
    let rules = ["length"];
    if (_apiPasswordSettings.data?.settings?.password_special_chars) {
      rules.push('specialChar');
    }
    if (_apiPasswordSettings.data?.settings?.password_with_number) {
      rules.push('number');
    }
    if (_apiPasswordSettings.data?.settings?.password_with_capital) {
      rules.push('capital');
    }
    rules.push('match');
    setPasswordCheckListSettings({
      password_length: _apiPasswordSettings.data?.settings?.password_length || 5,
      password_special_chars: _apiPasswordSettings.data?.settings?.password_special_chars || true,
      password_with_number: _apiPasswordSettings.data?.settings?.password_with_number || true,
      password_with_capital: _apiPasswordSettings.data?.settings?.password_with_capital || true,
      rules: rules
    })

  }, [_apiPasswordSettings.data]);

  const password = useWatch({
    control, name: 'newpassword', defaultValue: ''
  });
  const repeatpassword = useWatch({
    control, name: 'verifypassword', defaultValue: ''
  });

  const [passwordCheckListValid, setPasswordCheckListValid] = useState(false);

  const handleSave = async () => {
    await trigger();
    if (!isValid || !passwordCheckListValid) return;
    let data = getValues();
    data.username = currentUser.username;
    // console.log(data);
    // dispatch(actions.SaveNewPassword(data));
    _apiSaveNewPassword.mutate(data, {
      onSuccess: ({ data }) => {
        if (!data.isvalid) {
          ShowToast({ title: 'Change Unsuccessful', message: data.error, type: 'error' })
          return;
        }
        ShowToast({ title: 'Password Changed', message: 'Password successfully changed.', type: 'success' })
        handleDialogClose();
      }
    })
  }

  return (<>
    <form>
      <Dialog open={open} maxWidth="sm" fullWidth
        PaperComponent={PaperComponent}
        aria-labelledby="confirm-dialog-draggable"
      >
        <DialogTitle style={{ cursor: 'move' }} id="confirm-dialog-draggable" className="title-underline">Change Password</DialogTitle>
        <DialogContent style={{ overflowY: 'unset' }}>
          <Grid container spacing={3} style={{ marginTop: 10 }} justify="center">

            <Grid item xs={12} sm={5} md={4} >Old Password</Grid> <Grid item xs={12} sm={7} md={8} style={styleUserEntry.InputTopMargin}> <TextFieldInputOnChange control={control} name="oldpassword" type="password" label="" defaultValue={''} autoFocus />  </Grid>
            <Grid item xs={12} sm={5} md={4} >Password</Grid> <Grid item xs={12} sm={7} md={8} style={styleUserEntry.InputTopMargin}> <TextFieldInput properties={properties} field="newpassword" type="password" label="" defaultValue={''} />  </Grid>
            <Grid item xs={12} sm={5} md={4} >Repeat Password</Grid> <Grid item xs={12} sm={7} md={8} style={styleUserEntry.InputTopMargin}> <TextFieldInput properties={properties} field="verifypassword" type="password" label="" defaultValue={''} />  </Grid>
            <Grid item xs={12} sm={5} md={4} ></Grid> <Grid item xs={12} sm={7} md={8} style={styleUserEntry.InputTopMargin}>

              <PasswordChecklist
                rules={passwordCheckListSettings.rules}
                minLength={passwordCheckListSettings?.password_length || 5}
                value={password}
                valueAgain={repeatpassword}
                onChange={(isValid) => { setPasswordCheckListValid(isValid); }}
                className="password-checklist"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="secondary" onClick={() => {
            handleDialogClose();
          }} color="primary">
            Cancel
          </Button>
          <Button variant="primary" onClick={() => handleSave()}
          >
            Save New Password
          </Button>
        </DialogActions>
      </Dialog>
    </form>
  </>);
}

export default ChangePasswordDialog;